function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Gruppe_100",
  "data-name": "Gruppe 100",
  transform: "translate(1.703 -153.25)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Pfad_299",
  className: "burg",
  "data-name": "Pfad 299",
  d: "M1019.233,320.559V222.7l-15.32-3.552V203.159c15.544-29.311-17.075-31.42-17.075-31.42V147.283c-8.992-3.082-9.8-26.95-9.8-26.95.891,20.2-6.884,28.2-6.884,28.2V173.4c-.369.027-.7.075-1.055.112-27.139,2.657-11.159,31.2-11.159,31.2v16.432l-15.32,5.331v17.985L676.157,201.635v-34.45L640.185,126.55l-4.164,6.246-25.145,37.721v20.651l-138.9-20.984V132.545l-8.992-2V117.223L432.842,88.746l-27.477,27.479v16.32l-8.662,2.332v40.968L344.4,193.878l-30.3,10.446V188.171l-.413-.061v-.158L304,186.567V179.8l-9.883-.444s3.664-17.82-11.157-22.983V139.216s2.5-12.991-7.663-12.991H273.63a10.156,10.156,0,0,0-1.689.136v.158c-8.177,1.378-5.971,12.855-5.971,12.855v17.155c-14.823,5.161-11.159,22.981-11.159,22.981l-3.164,1.832V187l-8.495,2.832v86.373",
  transform: "translate(802.563 67.99)",
  fill: "none",
  stroke: "#e71d36",
  strokeMiterlimit: 10,
  strokeWidth: 5
}), /*#__PURE__*/React.createElement("path", {
  id: "Pfad_300",
  className: "berg",
  "data-name": "Pfad 300",
  d: "M-666.911,316.481H129.712l126.174-71.174,148.82-51.764,134.261-52.071L720.141,251.777l48.408,10.872,444.964-22.195,29.117,72.793h12.162",
  transform: "translate(665.208 143.199)",
  fill: "none",
  stroke: "#e71d36",
  strokeMiterlimit: 10,
  strokeWidth: 5
}));

var SvgCastle = function SvgCastle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1921.703,
    height: 308.93,
    viewBox: "0 0 1921.703 308.93",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCastle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Castle.4d78ce75.svg";
export { ForwardRef as ReactComponent };